import React, { useEffect, useState } from "react";
import CRUDForm from "./CRUDForm";
import { useParams } from "react-router-dom";
import { UnifiedFormParams, WebLatestNotifications } from "../../types";
import AxiosInstance from "../../API/axios";
import { BASE_API_URL } from "../../API/Base";

export const LatestNotificationUnifiedForn = () => {
  const { mode, id } = useParams<UnifiedFormParams>();
  const [apiData, setApiData] = useState<any>([]);

  const base64Decode = (encodedStr: string) => {
    return atob(encodedStr);
  };

  const decodedId = id ? base64Decode(id) : null;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await AxiosInstance.get(
          `${BASE_API_URL}/admin/web-content/v1/latest-notification/${decodedId}`
        );

        const data: WebLatestNotifications = response.data;
        setApiData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    if (mode !== "create") {
      fetchData();
    }
  }, [mode, decodedId]);

  const createFields =
    mode === "create"
      ? [
          { label: "City", key: "City_Id", type: "modal" },
          { label: "Address", key: "Address_1" },
        ]
      : apiData
      ? Object.keys(apiData)
          .filter(
            (key) =>
              ![
                "Id",
                "course_id",
                "category_id",
                "Module_Id",
                "status",
                "Sub_Module_Id",
                "Created_By",
                "Created_On",
                "Modify_By",
                "Modify_On",
                "sections",
                "lessons",
              ].includes(key)
          )
          .map((key) => ({ label: key, key }))
      : [];
  return (
    <div>
      {mode && ( // Check if mode exists
        <>
          <CRUDForm mode={mode} data={apiData} fields={createFields} />
        </>
      )}
    </div>
  );
};
